import script from "./DrawList.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawList.vue?vue&type=script&setup=true&lang=js"

import "./DrawList.vue?vue&type=style&index=0&id=185feba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-185feba0"]])

export default __exports__